import { render } from "./RecuperarSenha.vue?vue&type=template&id=29c68e7b&scoped=true"
import script from "./RecuperarSenha.vue?vue&type=script&lang=js"
export * from "./RecuperarSenha.vue?vue&type=script&lang=js"

import "./RecuperarSenha.vue?vue&type=style&index=0&id=29c68e7b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29c68e7b"]])

export default __exports__